import React, { useRef } from 'react';
import {
    useSsDispatch as useDispatch,
    useSsSelector as useSelector,
} from '~SpectateStore';
import { useTranslation } from 'react-i18next';

import {
    selectAvailableMultiSingles,
} from '~Betslip/selectors/availableBetTypesSelectors';
import {
    updateAllSelections,
} from '~Betslip/slices/userSelectionsSlice';
import {
    selectSinglesStake,
    selectSinglesEwSelected,
} from '~Betslip/selectors/userSelectionsSelectors';

import {
    selectAllSinglesPayout,
} from '~Betslip/selectors/singlesPayoutSelectors';

import {
    selectCountSuspendedSelections,
} from '~Betslip/selectors/selectionDetailsSelectors';

import {
    useKeyboard,
} from '~Betslip/store/keyboardContext';

import {
    useIsEachwayAllowed,
} from '~SpectateStore/hooks/userHooks';

import {
    selectHasTotalSinglesExceedBalance,
} from '~Betslip/selectors/userSelectors';

import {
    selectIsRefreshingBetslipData,
} from '~Betslip/selectors/uiSelectors';

import StakeField from '../StakeField';
import Payout from '../Payout';

import './styles.scss';

const Singles = () => {
    const [ t ] = useTranslation();
    const dispatch = useDispatch();
    const keyboardRef = useRef();
    const { setKeyboardContainerRef } = useKeyboard();
    const availableSingles = useSelector(selectAvailableMultiSingles);
    const stake = useSelector(selectSinglesStake);
    const each_way_selected = useSelector(selectSinglesEwSelected);
    const payout = useSelector(selectAllSinglesPayout);
    const totalSuspended = useSelector(selectCountSuspendedSelections);
    const { isDepositNeeded } = useSelector(selectHasTotalSinglesExceedBalance);
    const isEachwayAllowed = useIsEachwayAllowed();
    const isRefreshingBetslipData = useSelector(selectIsRefreshingBetslipData);

    if (!availableSingles) {
        return null;
    }

    const {
        name,
        total,
        each_way_allowed,
    } = availableSingles;

    const updateSelections = (stake, each_way_selected) => {
        dispatch(updateAllSelections({ stake, each_way_selected, free_bet_id: null }));
    };

    const openKeyboard = () => {
        setKeyboardContainerRef(keyboardRef.current);
    };

    const totalAvailableSingles = total - totalSuspended;

    const gtmDetails = {
        source: 'new-betslip',
        betType: 'singles',
    };

    return (
        <ul className="fullslip__bet-types">
            <li
                className="fullslip__bet-type"
                data-test-id="betslip;singles-singles"
            >
                <div
                    className="fullslip__bet-type-details"
                    data-test-id="betslip;bet-type-details"
                >
                    <div
                        className="fullslip__bet-name"
                        data-test-id="betslip;bet-type-name"
                    >
                        {t(`bet_types.name.${name}`)} (x{totalAvailableSingles})
                    </div>
                    <div className="fullslip__wager-text">
                        {t('betslip.wager_per_bet')}
                    </div>
                    <StakeField
                        stake={stake}
                        each_way_allowed={each_way_allowed && isEachwayAllowed}
                        each_way_selected={each_way_selected}
                        onChangeCallback={updateSelections}
                        onClickHandler={openKeyboard}
                        gtmDetails={gtmDetails}
                        depositRequired={isDepositNeeded}
                        disabled={isRefreshingBetslipData}
                    />
                    <Payout payout={payout} />
                </div>
                <div ref={keyboardRef} />
            </li>
        </ul>
    );
};

export default Singles;
